// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PEge1","name":"styles_name__1iHIH","phone":"styles_phone__IZYKW"};